import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { Loader2 } from "lucide-react";

export default function Onboarding() {
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.onboarding_completed) {
      navigate("/dashboard", { replace: true });
      return;
    }
    if (user) {
      const complete = async () => {
        try {
          await axios.post(`${API}/auth/onboarding-complete`, {}, { withCredentials: true });
        } catch {}
        await checkAuth();
        navigate("/dashboard", { replace: true });
      };
      complete();
    }
  }, [user, navigate, checkAuth]);

  return (
    <div className="min-h-screen mesh-bg flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground text-sm">Setting up your account...</p>
      </div>
    </div>
  );
}
